import styled, { css } from 'styled-components';
import { Spacing } from '../../enums';
import { palette } from '../../palette';
import { px, pxToRem, rem } from '../../utils';
import { createShouldForwardProp } from '../utils/createShouldForwardProp';
export const ProgressRoot = styled.div.withConfig({
  shouldForwardProp: createShouldForwardProp(['size'])
}).withConfig({
  componentId: "ds__sc-1lzm653-0"
})(["position:relative;width:", "};", " overflow:hidden;"], _ref => {
  let {
    size
  } = _ref;
  return typeof size === 'string' ? size : px(size);
}, _ref2 => {
  let {
    size
  } = _ref2;
  return typeof size !== 'undefined' && css(["height:", ";"], px(size));
});
export const ProgressBackground = styled.div.withConfig({
  componentId: "ds__sc-1lzm653-1"
})(["position:relative;width:100%;height:", ";background-color:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return px(theme.Progress.height);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.Progress.background;
});
export const ProgressValue = styled.div.withConfig({
  shouldForwardProp: createShouldForwardProp(['color', 'value', 'max'])
}).withConfig({
  componentId: "ds__sc-1lzm653-2"
})(["width:100%;height:100%;background:", ";transform:translateX(-100%);transform-origin:left;transition:transform ease-in-out 500ms;"], _ref5 => {
  let {
    theme,
    color
  } = _ref5;
  return theme.Progress.PROGRESS_COLOR_TO_COLOR[color] || palette[color];
});
export const ProgressValueLabel = styled.div.withConfig({
  componentId: "ds__sc-1lzm653-3"
})(["line-height:", ";text-align:right;transform:translateX(-100%);transform-origin:left;transition:transform ease-in-out 500ms;"], _ref6 => {
  let {
    theme
  } = _ref6;
  return rem(pxToRem(theme.Typography.TEXT_TYPE_TO_LINE_HEIGHT_PX.small[0], theme));
});
export const ProgressValueCirlceLabel = styled.div.withConfig({
  componentId: "ds__sc-1lzm653-4"
})(["position:absolute;left:0;top:0;width:calc(100% - ", ");height:calc(100% - ", ");display:flex;justify-content:center;align-items:center;margin:", ";overflow:hidden;"], px(2 * Spacing.SPACE_8), px(2 * Spacing.SPACE_8), px(Spacing.SPACE_8));